var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFdicLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 3.8C35.8 3.8 37.05 4.38 37.82 5.46V0.76C36.7 0.28 35.58 0 34.36 0C32.31 0 30.25 0.92 28.82 2.44C27.43 3.92 26.68 5.9 26.68 7.96C26.68 10.2 27.42 12.16 29.02 13.66C30.53 15.08 32.46 15.88 34.49 15.88C35.67 15.88 36.57 15.58 37.83 15.18V10.48C37.04 11.46 35.8 12.08 34.57 12.08C32.21 12.08 30.63 10.36 30.63 7.98C30.63 5.6 32.19 3.8 34.51 3.8M22.39 15.49H26.17V0.4H22.39V15.49ZM13.72 12.17H12.87V3.72H13.76C16.2 3.72 17.91 5.24 17.91 7.94C17.91 10.88 15.98 12.16 13.72 12.16M14.44 0.4H9.07V15.49H14.44C18.48 15.49 21.84 12.19 21.84 7.95C21.84 3.71 18.5 0.4 14.44 0.4ZM0 15.48H3.78V9.56H7.93V6.24H3.78V3.72H8.36V0.4H0V15.49V15.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdicLogoWhite);
export default __webpack_public_path__ + "static/media/FDICLogoWhite.7303e77c83fe61eb2198422cfe2ced4d.svg";
export { ForwardRef as ReactComponent };